import { useQuery, UseQueryOptions } from 'react-query';
import { getRosterFunctions } from 'RestAPIs/roster/functions';

const useGetRosterFunctions = (
  options?: UseQueryOptions<any, unknown, any>
) => {
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: ['rosterFunctions', 'list'],
    queryFn: async () => {
      const { data } = await getRosterFunctions();
      return data;
    },
    ...options
  });
  return { data, isFetching, isError, refetch };
};

export default useGetRosterFunctions;
